import React from 'react'
import {
	ClockCircleOutlined,
	FieldTimeOutlined,
	CheckCircleOutlined,
	HourglassOutlined,
	AppstoreOutlined,
	ScheduleOutlined,
	SettingOutlined,
	DashboardOutlined,
	MobileOutlined,
	BellOutlined,
	SafetyOutlined,
	BgColorsOutlined,
	PictureOutlined,
	EnvironmentOutlined,
	LaptopOutlined,
	UserOutlined,
	MessageOutlined,
	SafetyCertificateOutlined,
} from '@ant-design/icons'
import type { MenuProps } from 'antd'

export const getShiftTypeInfo = (menuKey: string) => {
	const shiftTypes: Record<string, { name: string; color: string }> = {
		'dynamic-shift': { name: 'Dynamic', color: 'blue' },
		'cleaner-shift': { name: 'Cleaner', color: 'green' },
		'night-shift': { name: 'Night', color: 'purple' },
		'pm-shift': { name: 'PM', color: 'orange' },
		'regular-shift': { name: 'Regular', color: 'cyan' },
		shift: { name: 'Shift', color: 'magenta' },
	}
	return shiftTypes[menuKey] || { name: 'Dynamic', color: 'blue' }
}

export const menuItems: MenuProps['items'] = [
	{
		key: 'dashboard',
		icon: React.createElement(DashboardOutlined),
		label: 'Dashboard',
	},
	{
		type: 'divider',
	},
	{
		key: 'config-shift',
		icon: React.createElement(SettingOutlined),
		label: 'Config Shift',
		children: [
			{
				key: 'dynamic-shift',
				icon: React.createElement(ClockCircleOutlined),
				label: 'Dynamic Shift',
			},
			{
				key: 'night-shift',
				icon: React.createElement(ClockCircleOutlined),
				label: 'Night Shift',
			},
			{
				key: 'pm-shift',
				icon: React.createElement(ClockCircleOutlined),
				label: 'PM Shift',
			},
			{
				key: 'hour-limitation',
				icon: React.createElement(FieldTimeOutlined),
				label: 'Hour Limitation',
			},
			{
				key: 'regular-shift-config',
				icon: React.createElement(CheckCircleOutlined),
				label: 'Regular Shift',
			},
			{
				key: 'cleaner-shift-config',
				icon: React.createElement(CheckCircleOutlined),
				label: 'Cleaner Shift',
			},
			{
				key: 'supposed-hours',
				icon: React.createElement(HourglassOutlined),
				label: 'Supposed Hours',
			},
		],
	},
	{
		type: 'divider',
	},
	{
		key: 'shift-management',
		icon: React.createElement(AppstoreOutlined),
		label: 'Shift Management',
		children: [
			{
				key: 'shift',
				icon: React.createElement(ClockCircleOutlined),
				label: 'All Shifts',
			},
			{
				key: 'dynamic-shift-management',
				icon: React.createElement(AppstoreOutlined),
				label: 'Dynamic Shifts',
			},
			{
				key: 'regular-shift-management',
				icon: React.createElement(ScheduleOutlined),
				label: 'Regular Shifts',
			},
		],
	},
	{
		type: 'divider',
	},
	{
		key: 'timezone-management',
		icon: React.createElement(ClockCircleOutlined),
		label: 'Timezone Management',
	},
	{
		type: 'divider',
	},
	{
		key: 'app-settings-group',
		icon: React.createElement(MobileOutlined),
		label: 'App Settings',
		children: [
			{
				key: 'app-version',
				icon: React.createElement(MobileOutlined),
				label: 'App Version',
			},
			{
				key: 'app-settings',
				icon: React.createElement(SettingOutlined),
				label: 'Mobile Leave Management',
			},
			{
				key: 'auth-options',
				icon: React.createElement(SafetyCertificateOutlined),
				label: 'Authentication Options',
			},
			{
				key: 'shift-reminder',
				icon: React.createElement(BellOutlined),
				label: 'Shift Reminder',
			},
			{
				key: 'message-types',
				icon: React.createElement(MessageOutlined),
				label: 'Message Types',
			},
		],
	},
	{
		type: 'divider',
	},
	{
		key: 'branding',
		icon: React.createElement(PictureOutlined),
		label: 'Branding',
	},
	{
		type: 'divider',
	},
	{
		key: 'fraud-detection-group',
		icon: React.createElement(SafetyOutlined),
		label: 'Fraud Detection',
		children: [
			{
				key: 'location-fraud',
				icon: React.createElement(EnvironmentOutlined),
				label: 'Location Fraud',
			},
			{
				key: 'device-change-tracking',
				icon: React.createElement(LaptopOutlined),
				label: 'Device Change Tracking',
			},
			{
				key: 'single-device-login',
				icon: React.createElement(UserOutlined),
				label: 'Single Device Login',
			},
		],
	},
	{
		type: 'divider',
	},
	{
		key: 'themes',
		icon: React.createElement(BgColorsOutlined),
		label: 'Themes',
	},
]
